<template>
  <router-link tag="button" class="btn btn-link mx-auto" id="button"
               :to="'abstract/' + abstract.id + '/preview'" v-if="abstract.status_id >= 1">
    <icon :icon="['fad', 'search']"/>
    <br>
    {{wording[0].buttons.preview}}
  </router-link>
  <button class="btn btn-link disabled mx-auto" v-else>
    <icon :icon="['fad', 'search']" class="disabled"/>
    <br>
    {{wording[0].buttons.preview}}
  </button>
</template>
<script>
  export default {
    name: 'PreviewArea',
    props: {
      abstract: {},
      wording: {}
    }
  }
</script>
<style scoped>
  @media (min-width: 10em) {
  }
</style>
